export default {
  data() {
    return {
      destroyed: false,
    };
  },
  props: ['text', 'buttons'],
  template: `<transition name="fade-from-right">
              <div class="talking-bird" v-if="!destroyed" v-on:click="destroyed = true">
                <div class="speech-bubble shadow">
                  <div class="text">{{text}}</div>
                  <div class="buttons">
                    <button @click="button.handler" 
                            v-for="(button, index) in buttons" 
                            :key="index"
                            class="button">{{ button.label }}</button>
                  </div>
                </div>
            
              </div>
            </transition>`,
};



// WEBPACK FOOTER //
// ./src/components/TalkingBird.js